import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=7927e62d&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=7927e62d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927e62d",
  null
  
)

export default component.exports